import { createAsyncThunk } from '@reduxjs/toolkit';
import { GET_PATIENT_ANALYTICS } from '@custom/constant';

const getPatientAnalytics = createAsyncThunk('getPatientAnalytics', async (query:any) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = `${GET_PATIENT_ANALYTICS}${query}`;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch analytics details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default getPatientAnalytics;
